<template>
	<div id="login" class="col-8">
		<h2>LOGIN</h2>
		<div v-if="$store.getters.isLoggedIn">
			<p>You are logged in as '{{ $store.getters.username }}'!</p>
			<br />
			<button class="btn btn-secondary form-control" v-on:click="logout()">
				Logout
			</button>
		</div>
		<div v-else id="login-form" class="input-group">
			<input
				class="form-control"
				v-model="username"
				type="text"
				placeholder="username"
			/>
			<input
				class="form-control"
				v-model="password"
				v-on:keyup.enter="login()"
				type="password"
				placeholder="password"
			/>
			<button class="btn btn-secondary form-control" v-on:click="login()">
				Login
			</button>
		</div>
	</div>
</template>

<script>
import * as user_api from '@/api/user';

export default {
	name: 'Login',
	data: function() {
		return {
			username: '',
			password: ''
		};
	},
	methods: {
		login: function() {
			user_api
				.login(this.username, this.password)
				.then(res => {
					this.$store.commit('setUser', res.data);
					this.password = '';
					let redirect = this.$route.query.redirect;
					if (redirect != null) {
						this.$router.push(String(redirect));
					}
				})
				.catch(error => {
					this.$store.commit('setUser', null);
					alert('login failure');
				});
		},
		logout: function() {
			user_api
				.logout()
				.then(res => {
					this.$store.commit('setUser', null);
				})
				.catch(error => {
					//alert('logout failure');
				});
		}
	}
};
</script>

<style scoped>
#login {
	margin: 0 auto;
	margin-top: 25px;
	max-width: 650px;
}
</style>
